import Ear from "../Ear";
import CardList from "../CardList";
import React, {Component} from "react";

import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import {getHash} from "../../utils";
import Footer from "../Footer";
import Cart from "../Cart";

const {preselectedItemId} = window;

const targetsRight = [
    { accepts: [2,1], droppedItem: null, realIndex: 0},
    { accepts: [2,1], droppedItem: null, realIndex: 1},
    { accepts: [2,1], droppedItem: null, realIndex: 2},
    { accepts: [2,1], droppedItem: null , realIndex: 3},
    { accepts: [1,2,3], droppedItem: null , realIndex: 4},
    { accepts: [1,2], droppedItem: null , realIndex: 5},
    { accepts: [1,2], droppedItem: null, realIndex: 6 },
    { accepts: [2], droppedItem: null , realIndex: 7},
    { accepts: [2], droppedItem: null, realIndex: 8 },
    { accepts: [2], droppedItem: null, realIndex: 9 },
    { accepts: [2], droppedItem: null , realIndex: 10},
];

const ROOT = 'MAIN-WRAPPER';

class DNDWrapper extends Component {
    state= {
        prevState: [],
        getters: targetsRight.concat(targetsRight),
        items: this.props.initialItems,
        currentItemType: null,
        //for special items that can be placed only in special getters
        acceptableGetters: [],
        itemsCount: 0,
        itemsSum: 0,
    };
    componentDidMount() {
        if(!preselectedItemId){
            return
        }
        const initialItem = this.getItemById(preselectedItemId);
        if(!initialItem){
            return;
        }
        const hash = getHash(0.0001, 0.99999);
        if(initialItem.accept){
            let newArr = this.state.getters.map((getter, index) => {
                if(index === initialItem.accept[0]){
                    return {...getter, droppedItem: {...initialItem, itemId: initialItem.itemId + hash}}
                }
                return getter;
            });
            return this.setState({getters: newArr},this.updateCountAndSum)
        }
        let itemAdded = false;
        let newArr = this.state.getters.map((getter) => {
            if(getter.accepts.includes(initialItem.type) && !itemAdded){
                itemAdded = true;
                return {...getter, droppedItem: {...initialItem, itemId: initialItem.itemId + hash}}
            }
            return getter;
        });
        return this.setState({getters: newArr},this.updateCountAndSum)
    }

    getItemById = id => {
        const hashPos = id.indexOf(".");
        const realId = hashPos !== -1 ? id.substr(0, hashPos  - 1) : id;
        return this.state.items.find(item => item.itemId === realId);
    };

    getGetterByIndex = index => this.state.getters[index];

    getDroppableIndex = value => {
        const num = value.replace(/[^0-9]/g, '');
        return parseInt(num,10);
    };

    updateCountAndSum = () => {
        const {getters} = this.state;
        let count = 0;
        const sum = getters.reduce((total, {droppedItem}) => {
            const hasItem = droppedItem !== null;
            hasItem && count++;
            return total + (hasItem ? droppedItem.price : 0);
        }, 0);
        this.setState({
            itemsCount: count,
            itemsSum: sum
        });
    };

    onDragEnd = result => {
        const {destination, source, draggableId} = result;
        // dropped outside the list
        if (!destination || destination.droppableId === source.droppableId) {
            this.setState({
                currentItemType: null,
                acceptableGetters: [],
            });
            return;
        }

        const targetGetterIndex = this.getDroppableIndex(destination.droppableId);
        const sourceGetterIndex = this.getDroppableIndex(source.droppableId);
        let draggedItem = this.getItemById(draggableId);
        let itemInsideTargetGetter;
        if(source.droppableId !== ROOT){
            itemInsideTargetGetter = this.getGetterByIndex(targetGetterIndex).droppedItem;
            if(itemInsideTargetGetter){
                const sourceGetterAccept = this.getGetterByIndex(sourceGetterIndex).accepts;
                if(!sourceGetterAccept.includes(itemInsideTargetGetter.type)){
                    this.setState({
                        currentItemType: null,
                        acceptableGetters: [],
                    });
                    return
                }
            }
        }
        switch (source.droppableId) {
            // dragging from cardlist
            case ROOT: {
                const itemWithNewIndex = {...draggedItem, itemId: draggedItem.itemId + getHash(0.0001, 0.99999)};
                this.setState(({getters, prevState}) => {
                    const newArray = getters.map((item, j) =>
                        j === targetGetterIndex ? {...item, droppedItem: itemWithNewIndex} : item
                    );
                    return {
                        prevState: [...prevState, getters],
                        getters: newArray,
                        currentItemType: null,
                        acceptableGetters: [],
                    };

                },this.updateCountAndSum);
                break;
            }
            // dragging from getter to getter
            default: {
                // return old index to dragged item
                draggedItem = {...draggedItem, itemId: draggableId};
                this.setState(({getters, prevState}) => {
                    const newArray = getters.map((item, j) => {
                        if (j === sourceGetterIndex) {
                            return {...item, droppedItem: itemInsideTargetGetter};
                        }
                        if (j === targetGetterIndex) {
                            return {...item, droppedItem: draggedItem};
                        } else {
                            return item;
                        }
                    });
                    return {
                        prevState: [...prevState, getters],
                        getters: newArray,
                        currentItemType: null,
                        acceptableGetters: [],
                    };

                },this.updateCountAndSum);
                break;
            }
        }
    };

    onBeforeCapture = result => {
        const {draggableId} = result;
        let item = this.getItemById(draggableId);
        this.setState({currentItemType: item.type, acceptableGetters: item.accept || []})
    };

    onSubmit = () => {
        const {getters} = this.state;
        const result = getters.reduce((acc, {droppedItem}) => {
            if(!droppedItem){
                return acc
            }
            const id = droppedItem.id;
            if(!acc.hasOwnProperty(id)){
                acc[id] = 0
            }
            acc[id]++;
            return acc;
        },{});

        const res = Object.entries(result).map(item => ({id: item[0], quantity: item[1]}));
        if(window.handleConstructorSubmit){
            window.handleConstructorSubmit(res)
        }
    };

    onClear = () => {
        const {getters, prevState} = this.state;
        this.setState({
            prevState: [...prevState, getters],
            getters: targetsRight.concat(targetsRight)
        })
    };

    onDelete = itemId => {
        const {getters, prevState} = this.state;
        const result = getters.map(getter => {
            if(getter.droppedItem && getter.droppedItem.itemId === itemId){
                return {...getter, droppedItem: null}
            }
            return getter
        });
        this.setState({
            prevState: [...prevState, getters],
            getters: result
        },this.updateCountAndSum);
    };

    onBack = () => {
        const {prevState} = this.state;
        if(prevState.length === 0) return;
        const newGetters = prevState[prevState.length - 1];
        const newPrevState = prevState;
        newPrevState.pop();
        this.setState({
            getters: newGetters,
            prevState: newPrevState,
        },this.updateCountAndSum)
    };

    render(){
        const {initialItems} = this.props;
        const {currentItemType, getters, itemsCount, itemsSum, acceptableGetters} = this.state;
        return (
            <>
                <DragDropContext onDragEnd={this.onDragEnd} onDragStart={this.onBeforeCapture}>
                    <Droppable droppableId={"MAIN-WRAPPER"} isDropDisabled={true}>
                        {(provided)  => (<div style={{display: "contents" }} ref={provided.innerRef}>
                                <Ear getters={getters} currentItemType={currentItemType} acceptableGetters={acceptableGetters}/>
                                <CardList items={initialItems}/>
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
                <Cart selected={getters.map(item => item.droppedItem).filter(item => item)} onDelete={this.onDelete} onClear={this.onClear}/>
                <Footer onSubmit={this.onSubmit} count={itemsCount} sum={itemsSum} onBack={this.onBack}/>
            </>)
    }
}


export default DNDWrapper
